export async function copyToClipboard(text: string) {
  if (!navigator.clipboard) {
    console.warn('Clipboard API not available')
    return
  }

  return navigator.clipboard.writeText(text)
}
